/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { all as allBooks, single, show as singleBook } from '../Store/api/books';
import addStudent from '../assets/images/add_student.svg';
import { changeAssignment } from '../Store/api/activities';
import { byBook as gatActivitiesByBook, changeAssignedDate } from '../Store/api/activities';
import { replaceActivity, setBook } from '../Store/entities/book';
import moment from 'moment';
import LicenseIcon from '../assets/images/licenseIcons.png';
import Frame1 from '../assets/images/frame1.png';
import Frame2 from '../assets/images/frame2.png';
import Frame3 from '../assets/images/frame3.png';
import greyledLearn from '../assets/images/grayledlearns.png';
import DatePicker from 'react-datepicker';
import { Portal } from 'react-overlays';
import funnel from '../images/funnel.svg';
import dummyImage from '../assets/images/book-cover.svg';
import GrayBook from '../assets/images/bookcover.png';
import CopyRight from '../assets/images/copyRight.svg';
import HumanCopyRight from '../assets/images/human.svg';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-loading-skeleton/dist/skeleton.css';
import arrow_down from '../assets/images/angle_up_down.svg';

import { GrayBox } from '../components/GrayBox';
import { Modal, ModalBody } from 'react-bootstrap';
import CustomDateInput from '../components/CustomDateInput';
import GrayledDropdown from '../components/GrayledDropdown';
import HtmlAsText from '../components/createmode/HtmlAsText';
import storage from '../services/storage';
import { classInfo } from '../Store/api/classApi';

export default function SideBar({ anchorBook = () => {}, handleActivityTitleClick = () => {}, lastBookId, scrollChapter = () => {}, scrollSection = () => {}, draggedOver = null, isDraggingActivity, draggedActivity, pageState = null, noBookSelect, handleShowDialoguebox = () => {}, modalShow, mode, bookRol, searchParam, joinCode, sectionData, tabContents = '', handleTabChange = () => {}, values = {}, selectedRole = '' }) {
  const user = storage.get('user');
  const [params] = useSearchParams();
  const bookID = params.get('bookId');
  const backTo = params.get('back_to');
  const bookId = localStorage.getItem('lastBookId');
  const token = localStorage.getItem('xAuthToken');

  const classes = useSelector((state) => state.entities.classes);

  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const { book, books = [] } = useSelector((state) => state.entities);
  const { reader } = useSelector((state) => state.ui.reader);
  const auth = useSelector((state) => state.auth);
  const { settings } = useSelector((state) => state.settings.settings);
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const [sideBarActivity, setSideBarActivity] = useState([]);
  const [tabContent, setTabContent] = useState(tabContents);
  const [subTab, setSubTab] = useState('all');
  const [showDatePicker, setShowDatePicker] = useState('');
  const [startDate, setStartDate] = useState('');
  const [activityDraggedOverElement, setActivityDraggedOverElement] = useState('');
  const { licenses } = useSelector((state) => state.entities.bookFelids.bookFields);

  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  /* No book Select */
  const location = useLocation();
  const isSignupFlow = location.pathname === `/signup/createclass`;
  //Create Class States
  const dispatch = useDispatch();
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }

  const [modalShows, setModalShows] = useState(false);
  const handleClose = () => {
    setModalShows(false);
    // Your closing logic here...
  };
  const handleCustomClick = () => {};

  const setTabs = (e, value) => {
    setTabContent(value);
    handleTabChange?.(value);
  };

  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };

  const toggleSidebarActivity = (e, value) => {
    if (sideBarActivity.includes(value)) {
      setSideBarActivity(sideBarActivity.filter((e) => e !== value));
    } else {
      setSideBarActivity([...sideBarActivity, value]);
    }
  }; // keeps track if API has already been called

  useEffect(() => {
    if (auth.token) {
      dispatch(
        classInfo({
          onSuccess: () => {
            // handle success if needed
          },
        })
      );
    }
  }, []);
  useEffect(() => {
    if (auth.token && (!user || user.role !== 'STUDENT')) {
      dispatch(
        allBooks({
          onSuccess: (res) => {
            dispatch(
              singleBook({
                id: lastBookId,

                onSuccess: (response) => {},
              })
            );
            dispatch(
              single({
                id: bookId || res.data.data[0]._id,

                onSuccess: (response) => {
                  dispatch(setBook(response.data.data.book));
                },
              })
            );
            dispatch(
              gatActivitiesByBook({
                id: bookId || res.data.data[0]._id,
                onSuccess: (res) => {},
              })
            );
          },
        })
      );
    }
  }, []);

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById('calendar-portal');
    return <Portal container={el}> {children} </Portal>;
  };
  const customDayStyle = (date, activity) => {
    const now = new Date();
    const assignment = new Date(activity.assignedDate);
    const isActivity = book.activities.findIndex((e) => new Date(e.assignedDate).getDate() === date.getDate() && new Date(e.assignedDate).getMonth() === date.getMonth() && new Date(e.assignedDate).getFullYear() === date.getFullYear());
    if (date.getDate() === assignment.getDate() && date.getMonth() === assignment.getMonth() && date.getFullYear() === assignment.getFullYear()) {
      return 'assigned-day assignment-day future';
    } else if (date.getDate() === 1) {
      return 'first-day';
    } else if (isActivity >= 0) {
      if ((date.getDate() > now.getDate() && date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && now.getMonth() < date.getMonth())) {
        return 'assignment-day future';
      } else {
        return 'assignment-day past';
      }
    } else if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
      return 'current-day';
    } else if (date.getDay() === 0) {
      return 'sunday';
    } else if ((date.getDate() > now.getDate() && date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth()) || date.getFullYear() > now.getFullYear() || (date.getFullYear() === now.getFullYear() && now.getMonth() < date.getMonth())) {
      return 'future-day';
    } else {
      return 'normal-day';
    }
  };

  const DynamicSpan = (props) => {
    const now = new Date();
    const assignementDate = new Date(props.date);
    const initialText = props.assigned ? new Date(props.date).toLocaleDateString('en-029', options) : `ASSIGN`;
    const [text, setText] = useState(initialText);
    const [isMouseTop, setIsMouseTop] = useState(false);
    const handleOver = (e) => {
      if (showDatePicker !== `${props.chapter}.${props.section}.${props.activity}`) setText(`${props.assigned ? initialText : 'ASSIGN'}`);
      setIsMouseTop(true);
    };
    const handleLeave = (e) => {
      setText(initialText);
      setIsMouseTop(false);
    };

    const handleClick = (e) => {
      e.stopPropagation();
      if (showDatePicker === `${props.chapter}.${props.section}.${props.activity}`) {
        setShowDatePicker('');
      } else {
        setShowDatePicker(`${props.chapter}.${props.section}.${props.activity}`);
      }
    };
    return (
      <div className={`${showDatePicker === `${props.chapter}.${props.section}.${props.activity}` ? '' : 'dynamic-span'}`}>
        {showDatePicker !== `${props.chapter}.${props.section}.${props.activity}` && (
          <div
            className='chepter'
            onMouseOver={handleOver}
            onMouseLeave={(e) => {
              handleLeave(e);
            }}
            onClick={(e) => {
              setStartDate(assignementDate !== '' ? new Date(assignementDate).toLocaleString('en-029') : new Date('1/1/1970').toLocaleString('en-029'));
              handleClick(e);
            }}
          >
            {(isMouseTop || showDatePicker) && text !== 'ASSIGN' && <div className='select-a-day'>select a day</div>}

            <div
              type='text'
              className='date-text'
              style={{
                textDecoration: `${text === 'ASSIGN' ? 'underline' : 'none'}`,
                color: `${text !== 'ASSIGN' && (now.getDate() < assignementDate.getDate() || now.getMonth() < assignementDate.getMonth() || now.getFullYear() < assignementDate.getFullYear()) ? '#6700B2' : 'gray'}`,
              }}
            >
              {text}
            </div>
          </div>
        )}
      </div>
    );
  };
  const onChangeDatePickerStartDate = (e, activity) => {
    dispatch(
      changeAssignedDate({
        id: activity._id,
        body: { assignedDate: e.toISOString() },
        onSuccess: (res) => {},
        onError: (error) => {},
      })
    );
    const newAct = {
      ...activity,
      assigned: true,
      assignedDate: e ? e.toISOString() : activity.assignedDate,
    };
    const index = book.activities.findIndex((e) => e._id === activity._id);
    setStartDate(e ? e.toLocaleString('en-029') : activity.assignedDate);
    dispatch(replaceActivity({ activity: newAct, index }));
    setShowDatePicker('');
  };

  const renderNewActivities = () => {
    return (
      <div className='Contents_tabs custom_tabs_chapater'>
        {' '}
        {book.activities.map((activity, actIndex) => (
          <div className='accordion-item activity-element' key={activity.chapter + '.' + activity.section + '.' + actIndex}>
            <h2 className='accordion-header activity-element'>
              <div
                // className={
                //   sideBarActivity.includes(`${chapter._id}-${section._id}-${activity._id}`) ? "accordion-button active main_head fw_700" : "accordion-button collapsed main_head fw_700"
                // }
                style={{ paddingLeft: '0px' }}
                className={`${sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`) ? 'accordion-button active main_head fw_700' : 'accordion-button main_head fw_700 collapsed'} ${activity.assigned ? 'assigned' : ''} activity-btn activity-element`}
                type='button'
                data-bs-toggle='collapse'
                data-bs-target='#panelsStayOpen-collapseKnowledge'
                aria-expanded={sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`)}
                aria-controls='panelsStayOpen-collapseKnowledge'
                onClick={(e) => {
                  toggleSidebarActivity(e, `${activity.chapter}-${activity.section}-${activity._id}`);
                }}
              >
                <div className='chap_title activity-element'>
                  <span className='eclipses'>{activity.title}</span>
                  <img src={arrow_down} alt='arrow' className='activity-element' />
                </div>{' '}
                <DynamicSpan activity={actIndex} chapter={activity.chapter} section={activity.section} assigned={activity.assigned} date={activity.assigned ? activity.assignedDate : ''} />
              </div>
            </h2>
            <div className='date-picker-wraper activity-element'>
              {showDatePicker === `${activity.chapter}.${activity.section}.${actIndex}` ? (
                <DatePicker
                  key={activity._id}
                  closeOnScroll={true}
                  selected={undefined}
                  open
                  renderDayContents={(day, date) => <div className={customDayStyle(date, activity)}>{day}</div>}
                  className='react-datepicker'
                  onClickOutside={(e) => {
                    if (!e.target.classList.contains('react-datepicker') && !e.target.classList.contains('date-input')) {
                      setShowDatePicker('');
                    }
                  }}
                  onChange={(e) => onChangeDatePickerStartDate(e, activity)}
                  popperContainer={CalendarContainer}
                  customInput={<CustomDateInput changeHandler={onChangeDatePickerStartDate} date={startDate} activity={activity} />}
                />
              ) : (
                ''
              )}
            </div>
            <div
              // id="panelsStayOpen-collapseSubdisciplines"
              className={sideBarActivity.includes(`${activity.chapter}-${activity.section}-${activity._id}`) ? 'accordion-collapse collapse event-less show' : 'accordion-collapse collapse event-less'}
              aria-labelledby='panelsStayOpen-Subdisciplines'
            >
              <div className='accordion-body event-less'>
                {activity.questions.map((question, quesIndex) => (
                  <div key={quesIndex} className='event-less'>
                    <p className='event-less'>
                      <a className='event-less'>{question.text}</a>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const dynamicChapterClass = (chapter, index) => {
    let className = 'accordion-button main_head chapter_element chapter-btn chapter_element_left';
    className += sideBar.includes(chapter._id) ? ' active' : ' collapsed';
    className += reader.chapter === index ? ' fw_700' : '';
    className += (draggedOver && draggedOver.type === 'chapter' && draggedOver.index === chapter._id) || (activityDraggedOverElement === chapter._id && mode === 'create') ? ' triggerss' : '';
    // className += book.activities.findIndex((e) => e.chapter === chapter._id) > -1 ? ' purple' : '';
    return className;
  };
  const dynamicSectionClass = (chapter, section, index, secIndex) => {
    let className = 'section-btn section_element section_element_left';
    className += (draggedOver && draggedOver.type === 'section' && draggedOver.index === chapter._id + '.' + section._id) || (activityDraggedOverElement === section._id && mode === 'create') ? ' triggersss' : '';
    className += sideBarSection.includes(`${chapter._id}-${section._id}`) ? ' accordion-button main_head active' : ' accordion-button main_head collapsed';
    // if (book.activities.findIndex((e) => e.section === section._id) > -1) {
    //   className += ' purple';
    // }
    return className;
  };

  const renderChapters = () => {
    return (
      <div
        className='tab-pane fade show active custom_tabs_chapater'
        onMouseLeave={() => {
          setActivityDraggedOverElement('');
        }}
      >
        <h1 className='f-16 mini_title book-title-left'>{book?.title || ''}</h1>

        <div className='accordion mb-0' id='accordion_active' style={{ marginTop: '0px' }}>
          {book.chapters.map((chapter, index) => {
            const chapActivities = book.activities.filter((e) => e.chapter === chapter._id && !e.section);
            const chapActivity = chapActivities[0];
            return (
              <div key={index}>
                <div className={`accordion-item`}>
                  <h2 className='accordion-header'>
                    <div
                      onMouseEnter={() => {
                        if (isDraggingActivity) {
                          setActivityDraggedOverElement(chapter._id);
                        }
                      }}
                      onMouseUp={() => {
                        if (isDraggingActivity) {
                          const draggedActivityIndex = book.activities.findIndex((e) => e._id === draggedActivity._id);

                          dispatch(
                            changeAssignment({
                              id: draggedActivity._id,
                              body: { chapter: chapter._id },
                              onSuccess: (res) => {
                                dispatch(
                                  replaceActivity({
                                    activity: {
                                      ...draggedActivity,
                                      chapter: chapter._id,
                                      section: '',
                                      paragraphs: [],
                                    },
                                    index: draggedActivityIndex,
                                  })
                                );
                              },
                              onError: (error) => {},
                            })
                          );
                        }
                        setActivityDraggedOverElement('');
                      }}
                      className={dynamicChapterClass(chapter, index)}
                      type='button'
                      aria-controls='panelsStayOpen-collapsePreface'
                      data-id={chapter._id}
                      aria-expanded={sideBar.includes(chapter.title) ? true : false}
                      style={{ padding: '0px' }}
                    >
                      {'    '}{' '}
                      <div
                        style={{
                          borderRadius: '2px',
                          padding: '4px  6px 4px 2px',
                        }}
                        className={` chap_title ${sideBar.includes(chapter._id) ? 'bg_grey' : ''}`}
                        onClick={(e) => {
                          scrollChapter(chapter?._id);
                          expendSidebar(e, chapter._id);
                        }}
                      >
                        <span
                          className='
                        eclipses
                        '
                        >
                          <HtmlAsText htmlContent={chapter.title} />
                        </span>
                        {chapter?.sections?.length > 0 && <img src={arrow_down} alt='arrow' />}
                      </div>{' '}
                    </div>
                  </h2>
                  <div className='date-picker-wraper activity-element'>
                    {showDatePicker === `${chapter._id}` && (
                      <DatePicker
                        // selected={new Date(activity.assignedDate)}
                        closeOnScroll={true}
                        selected={undefined}
                        open
                        renderDayContents={(day, date) => <div className={customDayStyle(date, chapActivity)}>{day}</div>}
                        className='react-datepicker'
                        // popperPlacement="top-start"
                        onClickOutside={(e) => {
                          if (!e.target.classList.contains('react-datepicker') && !e.target.classList.contains('date-input')) {
                            setShowDatePicker('');
                          }
                        }}
                        onChange={(e) => onChangeDatePickerStartDate(e, chapActivity)}
                        popperContainer={CalendarContainer}
                        customInput={<CustomDateInput changeHandler={onChangeDatePickerStartDate} activity={chapActivity} date={startDate} />}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      marginBottom: chapter.sections.length > 0 ? '8px' : '0px',
                    }}
                    // id="panelsStayOpen-collapsePreface"
                    className={sideBar.includes(chapter._id) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'}
                    aria-labelledby='panelsStayOpen-Preface'
                  >
                    {/* <div className="accordion-body">
                    <p className="f14">{chapter.description}</p>
                  </div> */}
                    <div
                      className='accordion-body bl'
                      style={{
                        marginLeft: '5px',
                        // marginTop: chapter.sections.length > 0 ? '10px' : '0px',

                        display: chapter.sections.length > 0 ? 'flex' : 'none',
                        flexDirection: 'column',
                        gap: '8px',
                      }}
                    >
                      {book.activities
                        .filter((e) => e.chapter === chapter?._id && !e.section)
                        .map((e, index) => (
                          <div key={index} className='section_element'>
                            <div className='accordion-item'>
                              <h2 className='accordion-header'>
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '0px 0px',
                                    fontWeight: '400',
                                  }}
                                  className={dynamicChapterClass(chapter, index)}
                                  data-id={`${chapter._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}`)}
                                >
                                  <div
                                    className='purple'
                                    style={{ fontWeight: '400' }}
                                    onClick={(event) => {
                                      scrollChapter(chapter?._id);
                                      toggleSidebarSection(event, `${chapter._id}`);
                                      handleActivityTitleClick(e?._id);
                                    }}
                                  >
                                    <HtmlAsText htmlContent={e.title} style={{ fontWeight: '400' }} />
                                  </div>{' '}
                                </button>
                              </h2>
                            </div>
                          </div>
                        ))}

                      {chapter.sections.map((section, secIndex) => {
                        const sectActivities = book.activities.filter((e) => e.section === section._id && !e.paragraphs.length);
                        const sectActivity = sectActivities[0];
                        return (
                          <div key={secIndex} className='section_element'>
                            <div className='accordion-item'>
                              <h2 className='accordion-header'>
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '3px 0px',
                                  }}
                                  className={dynamicSectionClass(chapter, section, index, secIndex)}
                                  data-id={`${chapter._id}.${section._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}-${section._id}`)}
                                  onMouseEnter={(e) => {
                                    e.stopPropagation();
                                    if (isDraggingActivity) {
                                      setActivityDraggedOverElement(section._id);
                                    }
                                  }}
                                  onMouseUp={(e) => {
                                    // e.stopPropagation();
                                    if (isDraggingActivity) {
                                      const draggedActivityIndex = book.activities.findIndex((e) => e._id === draggedActivity._id);
                                      dispatch(
                                        changeAssignment({
                                          id: draggedActivity._id,
                                          body: {
                                            chapter: chapter._id,
                                            section: section._id,
                                          },
                                          onSuccess: (res) => {
                                            dispatch(
                                              replaceActivity({
                                                activity: {
                                                  ...draggedActivity,
                                                  chapter: chapter._id,
                                                  section: section._id,
                                                  paragraphs: [],
                                                },
                                                index: draggedActivityIndex,
                                              })
                                            );
                                          },
                                          onError: (error) => {},
                                        })
                                      );
                                    }
                                    setActivityDraggedOverElement('');
                                  }}
                                >
                                  <div
                                    className='chap_title'
                                    onClick={(e) => {
                                      scrollSection(`${chapter._id}.${section._id}`);
                                      toggleSidebarSection(e, `${chapter._id}-${section._id}`);
                                    }}
                                  >
                                    <HtmlAsText htmlContent={section?.title} />

                                    {/* {book.activities.some((e) => e.section === section._id) && <img onClick={(e) => toggleSidebarSection(e, `${chapter._id}-${section._id}`)} src={arrow_down} alt='arrow' />} */}
                                    {(book.activities.some((e) => e.section === section._id && !e.paragraph) || section?.paragraphs?.some((p) => book.activities.some((e) => e.paragraphs?.includes(p._id)))) && <img onClick={(e) => toggleSidebarSection(e, `${chapter._id}-${section._id}`)} src={sideBarSection.includes(`${chapter._id}-${section._id}`) ? arrow_down : arrow_down} alt='arrow' style={{ cursor: 'pointer' }} />}
                                  </div>{' '}
                                </button>
                                {(book.activities.some((e) => e.section === section._id && !e.paragraph) || section?.paragraphs?.some((p) => book.activities.some((e) => e.paragraphs?.includes(p._id)))) && (
                                  <div className={sideBarSection.includes(`${chapter._id}-${section._id}`) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} aria-labelledby='panelsStayOpen-Biological'>
                                    <div
                                      className='accordion-body bl'
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                      }}
                                    >
                                      {book.activities
                                        .filter((e) => e.section === section._id && !e.paragraph)
                                        .map((e, index) => (
                                          <div key={index} className='section_element'>
                                            <div className='accordion-item'>
                                              <h2 className='accordion-header'>
                                                <button
                                                  style={{
                                                    textTransform: 'capitalize',
                                                    margin: '0px 1px 0px 16px',
                                                    padding: '0px 0px',
                                                    fontWeight: '400',
                                                  }}
                                                  className={dynamicSectionClass(section, section, index)}
                                                  data-id={`${section._id}`}
                                                  type='button'
                                                  data-bs-toggle='collapse'
                                                  aria-expanded={sideBarSection.includes(`${chapter._id}-${section._id}`)}
                                                >
                                                  <div
                                                    className='purple'
                                                    style={{ fontWeight: '400' }}
                                                    onClick={(event) => {
                                                      scrollChapter(`${chapter?._id}.${section?._id}`);
                                                      toggleSidebarSection(event, `${chapter._id}.${section._id}`);
                                                      handleActivityTitleClick(e?._id);
                                                    }}
                                                  >
                                                    <HtmlAsText htmlContent={e.title} style={{ fontWeight: '400' }} />
                                                  </div>{' '}
                                                </button>
                                              </h2>
                                            </div>
                                          </div>
                                        ))}
                                      {/* {section?.paragraphs &&
                                      section.paragraphs.map((paragraph) => {
                                        const pActivity = book.activities.find((e) => e.paragraphs.includes(paragraph._id));
                                        return (
                                          paragraph.text && (
                                            <div key={paragraph._id}>
                                              <div className='accordion-item p-element'>
                                                <h2 className='accordion-header'>
                                                  <div className='accordion-body' style={{ marginTop: '0px' }}>
                                                    <div>
                                                      <p className='left-ps mb-0'>
                                                        <a
                                                          style={{
                                                            marginBottom: '0px',
                                                            fontWeight: '500',
                                                            textTransform: 'default',
                                                            pointerEvents: 'auto',
                                                            color: 'inherit',
                                                          }}
                                                          className={`cursor eclipses ps ${book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 && 'purple'}`}
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            dispatch(setChapter(index));
                                                            dispatch(setSection(secIndex));
                                                            if (anchorBook) anchorBook(chapter._id, section._id, paragraph._id);
                                                          }}
                                                        >
                                                          <HtmlAsText htmlContent={paragraph.text || 'Paragraph'} />
                                                        </a>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </h2>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })} */}
                                    </div>
                                  </div>
                                )}
                              </h2>
                              <div className='date-picker-wraper activity-element'>
                                {showDatePicker === `${section._id}` && (
                                  <DatePicker
                                    // selected={new Date(activity.assignedDate)}
                                    closeOnScroll={true}
                                    selected={undefined}
                                    open
                                    renderDayContents={(day, date) => <div className={customDayStyle(date, sectActivity)}>{day}</div>}
                                    className='react-datepicker'
                                    onClickOutside={(e) => {
                                      if (!e.target.classList.contains('react-datepicker') && !e.target.classList.contains('date-input')) {
                                        setShowDatePicker('');
                                      }
                                    }}
                                    onChange={(e) => onChangeDatePickerStartDate(e, sectActivity)}
                                    popperContainer={CalendarContainer}
                                    customInput={<CustomDateInput changeHandler={onChangeDatePickerStartDate} activity={sectActivity} date={startDate} />}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const currentBook = bookID || lastBookId ? books?.all?.find((item) => item._id === (bookID || lastBookId)) : books?.all?.[0] || {};
  const current_license = licenses.find((item) => item.label === currentBook?.license) || {};

  return (
    <div className='h-100'>
      <div
        onClick={() => {
          if (!modalShow && token && settings.siteMode !== 'teach') {
            handleShowDialoguebox();
          }
        }}
        className={`cursor ${settings.siteMode === 'teach' ? 'left_side_bar teach custom_nav' : 'left_side_bar custom_nav'}`}
        style={{
          display: settings.bookMode ? 'none' : 'block',
        }}
      >
        <div
          className={`logo_wrap ${settings.siteMode === 'teach' ? 'd-flex' : ''}`}
          style={{
            marginBottom: '25.02px',
            height: '34px',
            justifyContent: 'start',
          }}
        >
          {auth?.token && settings.siteMode === 'teach' ? (
            <Fragment>
              <GrayledDropdown mode='assign' />
            </Fragment>
          ) : mode === 'explore' ? (
            <img src='/assets/images/auth_logo.svg' alt='auth_picture' />
          ) : (
            ''
          )}
          {!auth.token && !joinCode ? <img className='' src={searchParam === 'student' && (pageState === 1 || pageState === 2 || pageState === 4) ? greyledLearn : '/assets/images/auth_logo.svg'} alt={searchParam === 'student' ? 'learn_picture' : 'auth_picture'} /> : joinCode ? <img className='' src={greyledLearn} alt='learn_picture' /> : null}
        </div>

        <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
          <li className={`nav-item`} role='presentation'>
            <button
              className={`nav-link 
              ${tabContent === 'content' && !isSignupFlow ? 'active' : ''}
              ${isSignupFlow || !auth?.token || !auth?.user ? 'no-hover' : ''}
            `}
              id='home-tab'
              data-bs-toggle='tab'
              data-bs-target='#Contents'
              type='button'
              role='tab'
              aria-controls='Contents'
              aria-selected='true'
              onClick={(e) => {
                if (tabContent === 'class') {
                  handleShowDialoguebox();
                  setTabs(e, 'content');
                }
              }}
              disabled={!auth || !auth.token || !auth.user}
            >
              Contents
            </button>
          </li>
          <li className={`nav-item ${!auth || !auth.token || !auth.user ? 'disabled' : ''}`} role='presentation'>
            <button
              className={`${tabContent === 'class' ? 'nav-link active' : 'nav-link'} ${!auth || !auth.token || !auth.user ? 'disabled' : ''}`}
              disabled={!auth || !auth.token || !auth.user}
              id='classroom-tab'
              data-bs-toggle='tab'
              data-bs-target='#classroom'
              type='button'
              role='tab'
              aria-controls='profile'
              aria-selected='false'
              onClick={(e) => {
                if (tabContent === 'content') {
                  setTabs(e, 'class');
                }
              }}
            >
              classroom
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div className={tabContent === 'content' ? 'tab-pane fade show active' : 'tab-pane fade show'} id='Contents' role='tabpanel' aria-labelledby='Contents-tab'>
            <div className='Contents_tabs'>
              <div className='tabs_content classroom_wrap' id='myContents'>
                {subTab === 'all' ? (
                  <div className='tab-pane fade show active custom_tabs_chapater' aria-labelledby='all-tab'>
                    {lastBookId && renderChapters()}
                  </div>
                ) : (
                  ''
                )}
                {subTab === 'activities' ? (
                  <div className='tab-pane fade show active' aria-labelledby='Activities-tab'>
                    {renderNewActivities()}
                  </div>
                ) : (
                  ''
                )}
                {subTab === 'activities-chapters' ? (
                  <div>
                    <div className='sidebar_subheading'>
                      <span> CHAPTERS</span>
                      <img src={funnel} alt='' />
                    </div>
                    <hr />
                    <div className='vh-50'>{lastBookId && renderChapters()}</div>
                    <div className='sidebar_subheading'>
                      <span> ACTIVITIES</span>
                      <img src={funnel} alt='' />
                    </div>
                    <hr />
                    <div className='vh-50'>{renderNewActivities()}</div>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <ul className='nav nav-tabs' id='myContents_two' role='tablist'>
                <li className='nav-item' role='presentation'>
                  <button
                    className={subTab === 'all' ? 'nav-link active' : 'nav-link'}
                    id='all-tab'
                    data-bs-toggle='tab'
                    data-bs-target='#all'
                    type='button'
                    role='tab'
                    aria-controls='all'
                    aria-selected='true'
                    onClick={(e) => {
                      setSubTab('all');
                    }}
                  >
                    Book Contents
                  </button>
                </li>

                <li className='nav-item' role='presentation'>
                  <button
                    className={subTab === 'activities-chapters' ? 'nav-link active' : 'nav-link'}
                    id='Chapters-tab'
                    data-bs-toggle='tab'
                    data-bs-target='#Chapters'
                    type='button'
                    role='tab'
                    aria-controls='Chapters'
                    aria-selected='false'
                    onClick={(e) => {
                      setSubTab('activities-chapters');
                    }}
                  >
                    Book & Activities
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className={tabContent === 'class' ? 'tab-pane fade show active' : 'tab-pane fade show'} id='classroom' role='tabpanel' aria-labelledby='classroom-tab'>
            <div className='tabs_content classroom_wrap cursor_default' style={{ overflowY: 'clip' }}>
              {books.all.length > 0 ? (
                <div style={{ background: '#FFF' }}>
                  {auth && auth.token && auth.user && backTo !== 'classes' ? (
                    <div className='class_room_box'>
                      <div className='class_room_img'>
                        <img src={currentBook?.coverImage || currentBook?.bookDetailCoverUrl || dummyImage} alt='class_rom_img gggg' className='class_rom_img  class-room-invite' />
                      </div>
                      <div className='class_room_content pdl-20'>
                        <div className='content_top'>
                          <h6 className='text-uppercase text-grey'>
                            You're reading: <span></span>
                          </h6>
                          <h5>{currentBook?.title}</h5>
                          <p>Written by: {auth && auth.token && auth.user ? book.author : currentBook?.author}</p>
                          <p>{new Date(auth && auth.token && auth.user ? book.createdAt : currentBook?.createdAt).getFullYear() || '2022'}</p>
                          <div className='copy_rights'>
                            {current_license?.img_url && <img src={current_license.img_url} alt='CC' />}
                            {current_license?.img_url2 && <img src={current_license.img_url2} alt='BY' />}
                            {current_license?.img_url3 && <img src={current_license.img_url3} alt='NC' />}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : bookRol === 'professor' ? (
                    <div className='class_room_box'>
                      <div className='class_room_img'>
                        <img src={dummyImage} alt='class_rom_img gggg' className='class_rom_img' />
                      </div>
                      <div className='class_room_content pdl-20'>
                        <div className='content_top'>
                          <h6 className='text-uppercase text-grey'>
                            You're reading: <span></span>
                          </h6>
                          <h5>
                            {/* {books.all[0].title} */}
                            Semillas Elementary Spanish 1
                          </h5>
                          <p className=''>
                            Written by: John Smith
                            {/* {auth && auth.token && auth.user
                              ? book.author
                              : books.all[0].author} */}
                          </p>
                          <p className=''>
                            2022
                            {/* {new Date(
                              auth && auth.token && auth.user
                                ? book.createdAt
                                : books.all[0].createdAt
                            ).getFullYear()} */}
                          </p>
                          <div className='copy_rights'>
                            <img src={CopyRight} alt='copyrights' />
                            <img src={HumanCopyRight} alt='lisence' />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <ContentGreyboxes noBookSelect={((pageState === 3 || pageState === 4) && selectedRole === 'student') ? true: false} />
                  )}
                </div>
              ) : (
                <div>
                  <ContentGreyboxes noBookSelect={ ((pageState === 3 || pageState === 4) && selectedRole === 'student') ? true: false} role={selectedRole} />
                </div>
              )}

              <div>
                <h5 className='classroom_heading mt-64 mb-0'>your classroom</h5>
                {/* {auth.token && ( */}
                <div
                  style={{
                    overflowY: 'scroll',
                    height: 'calc(100vh - 446px)', // Adjust as needed
                  }}
                >
                  {auth && auth.user && auth.token ? (
                    <div className='spn_wrap mt-25'>
                      <div className='spn_inner'>
                        {classes.classes.length < 1 ? (
                          <div>
                            <div className='spn_wrap mt-25'>
                              <div className='spn_inner'>
                                <GrayBox />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            {backTo === 'classes' && Object.keys(values).length > 0 ? (
                              <RenderClassesDetails
                                {...{
                                  ...values,
                                  sections: values.currentSection?.sectionName || values.currentSection?.sectionNumber ? [...values.sections, values.currentSection] : values.sections,
                                  emailsMap,
                                }}
                              />
                            ) : (
                              classes.classes.map((el, index) => (
                                <RenderClassesDetails
                                  key={index}
                                  {...{
                                    ...el,
                                    schedule: el?.schedule?.split(',') || [],
                                    emailsMap,
                                  }}
                                />
                              ))
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className='spn_wrap mt-25'>
                        <div className='spn_inner'>
                          <GrayBox />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <>
        {/* Your other content here... */}
        <Modal show={modalShows} onHide={handleClose} backdrop='static' className='modal fade custom_modal_not model_with' id='Not_yet' tabIndex='-1' aria-labelledby='Not_yetLabel' aria-hidden='true'>
          <div className='modal-width'>
            <ModalBody>
              <button onClick={handleClose} type='button' className='btn_close_modal' data-bs-dismiss='modal' aria-label='Close'>
                <img src='/assets/images/cross.png' alt='cross' />
              </button>
              <div className='modal-body modal_content_main_Wrap'>
                <div className='modal_content_box' style={{ marginLeft: '0px' }}>
                  <h1>not yet!</h1>
                  <p>Complete signup to see assignments, read the book and connect with other students in your class.</p>
                </div>
                <div className='btn_wrap_info' style={{ marginTop: '40px' }}>
                  {/* Customize the onClick event for this button */}
                  <button type='button' className='btn_black_theme' onClick={handleCustomClick}>
                    Take me back to signup
                    {/* Take me back to signup */}
                  </button>
                  <button type='button' className='btn_outline_dark mt_24'>
                    I just want to read
                  </button>
                </div>
              </div>
            </ModalBody>
          </div>
        </Modal>
      </>
    </div>
  );
}

export const ContentGreyboxes = ({ noBookSelect, role = '' }) => (
  <div className='class_room_box w-100 gap-4'>
    <div className='class_room_img_greybox'>
      <img src={GrayBook} alt='class_rom_img' className='class_rom_img' />
    </div>
    <div className='class_room_content ' style={{ display: 'block' }}>
      <div className='content_top' style={{ paddingTop: '10px' }}>
        {noBookSelect ? (
          <Fragment>
            {' '}
            <h6 className='text-uppercase text-grey mb-0 book-width'>No book selected</h6>
            {role === 'student' && 
              <h6 className='no-book-return'>
                Return to Greyled library <span>--&gt;</span>
              </h6>
            }
          </Fragment>
        ) : (
          <Fragment>
            {' '}
            <h6 className='text-uppercase text-grey mb-0 book-width'>
              You're reading: <span></span>
            </h6>
            <div className='book_graybox_height book-width' style={{ paddingBottom: '2px' }}>
              <img src={Frame1} alt='copyrights' />
            </div>
            <div className='book_graybox_height graybox-1 book-width'>
              <img src={Frame2} alt='copyrights' />
            </div>
            <div className='book_graybox_height graybox-1 book-width'>
              <img src={Frame3} alt='copyrights' />
            </div>
            <div className='book_graybox_height graybox-2 book-width'>
              <img src={LicenseIcon} alt='copyrights' />
              <img src={LicenseIcon} style={{ marginLeft: '8px' }} alt='lisence' />
            </div>
          </Fragment>
        )}
      </div>
    </div>
  </div>
);

const RenderClassesDetails = ({ courseNumber, courseName, startDate, endDate, sections = [], mode, schedule = [], emailsMap }) => (
  <div className='sidbar-mar'>
    <h5>
      {courseNumber}
      {courseName && courseNumber && ':'} {courseName}
      <span>
        {startDate ? moment(startDate).format('MMM') : ''}
        {startDate && endDate && '-'} {endDate ? moment(endDate).format('MMM   YYYY') : ''}
      </span>
    </h5>

    {sections?.length > 0 ? (
      <div className='section_class'>
        {sections?.map((item, index) => (
          <div className='d-flex justify-content-between' key={index}>
            <div className='sidbar-mar'>
              <h5>
                {item?.sectionName} {item?.sectionNumber.split('-')[0]}
              </h5>
              <div className='section_class_inner'>
                <div className='contetn_class'>
                  <h3>
                    <span className=''>Instructor</span>
                    {item.instructorEmails.length > 0 && (
                      <span className='fw-normal'>
                        {(() => {
                          const firstEmail = item.instructorEmails[0].email || item.instructorEmails[0];
                          const name = emailsMap[firstEmail] ? `${emailsMap[firstEmail].firstName} ${emailsMap[firstEmail].lastName}` : firstEmail;

                          if (name) {
                            const displayName = name.length > 16 ? `${name.slice(0, 16)}...` : name;
                            const moreCount = item.instructorEmails.length - 1;

                            return `${displayName}${moreCount > 0 ? ` +${moreCount} instructor${moreCount > 1 ? 's' : ''}` : ''}`;
                          }
                        })()}
                      </span>
                    )}
                  </h3>
                  <h3>
                    <span className=''>Students</span> {schedule.length > 0 ? <span className='fw-normal'>0 enrolled</span> : ''}
                  </h3>

                  <h3>
                    <span className=''>Schedule</span>
                    {schedule?.length > 0 ? <span className='fw-normal'>{schedule?.map((word) => word.trim())} 10:30 am - 12:30 pm</span> : ''}
                  </h3>
                </div>{' '}
                <u></u>{' '}
              </div>
            </div>
            {mode === 'assign' && (
              <div className='sidbar-mar add-students d-flex align-items-center'>
                <img className='cursor' src={addStudent} alt='addStudent' />
              </div>
            )}
          </div>
        ))}
      </div>
    ) : (
      <div className='empty_box'>
        <div className='body_box mb_32'>
          <div className='head_box  mb_12'> </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_50  mb_8  '></div>
          </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_60  mb_10'></div>
          </div>
        </div>
        <div className='body_box mb_32'>
          <div className='head_box  mb_12'> </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_50  mb_8'></div>
          </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_60 mb_8'></div>
          </div>
        </div>
        <div className='body_box mb_32'>
          <div className='head_box  mb_12'> </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_50  mb_8'></div>
          </div>
          <div className='content_box_inner d-flex  justify-content-between'>
            <div className='box_60 mb_10'></div>
          </div>
        </div>
      </div>
    )}
  </div>
);
